import React from 'react';
import { Button } from './ui/button';
import { Check, ArrowRight } from 'lucide-react';
import { heroData } from '../mock/data';

const Hero = () => {
  const scrollToPricing = () => {
    const element = document.querySelector('#pricing');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#e8f5ef] via-[#f0f9f4] to-white">
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-10 w-72 h-72 bg-[#52a675]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-[#52a675]/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 lg:animate-in lg:fade-in lg:slide-in-from-left lg:duration-700">
            <div className="space-y-4">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                {heroData.title}{' '}
                <span className="text-[#52a675] block lg:inline">{heroData.titleHighlight}</span>
              </h1>
              <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
                {heroData.description}
              </p>
            </div>

            <Button
              size="lg"
              onClick={scrollToPricing}
              className="bg-[#52a675] hover:bg-[#3d8a5c] text-white px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              {heroData.ctaText}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>

            {/* Features */}
            <div className="flex flex-wrap gap-4 pt-4">
              {heroData.features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-2 bg-white px-4 py-2 rounded-full shadow-md hover:shadow-lg transition-shadow"
                >
                  <div className="w-6 h-6 bg-[#52a675] rounded-full flex items-center justify-center">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-sm font-medium text-gray-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative lg:animate-in lg:fade-in lg:slide-in-from-right lg:duration-700 lg:delay-150">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/generated/hero-swiss-road.jpg"
                alt="Voiture moderne sur route panoramique suisse"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl max-w-xs animate-in fade-in slide-in-from-bottom duration-700 delay-300">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-[#52a675]/10 rounded-full flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="w-6 h-6 text-[#52a675]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">+1500 clients</p>
                  <p className="text-xs text-gray-500">satisfaits</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#52a675] rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-[#52a675] rounded-full mt-2" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
